import React, { useEffect, useState } from 'react'
import styles from './Home.module.css'
import Typewriter from '../TypeWritter/TypeWritter'
import JumpingBar from '../JumpingBar/JumpingBar'
import About from './About/About'
import Section from './Section/Section'
import Projects from './Projects/Projects'
import { HoverState } from '../../assets/utils/cursorTypes'
import Experience from './Experience/Experience'
import Contact from './Contact/Contact'
import { smoothScrollTo } from '../../assets/utils/smoothScroll'
import { useLocation } from 'react-router-dom'

export type HomeProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
    navbarRef: React.RefObject<HTMLDivElement | null>;
    setNavOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const Home = (props: HomeProps) => {

    const [blurElement, setBlurElement] = useState('');
    const location = useLocation();

    const handleScroll = (target: string) => {
        const targetElement = document.getElementById(target.toString());
        if (targetElement) {
            props.setNavOpened(false);
            const navbarHeight = target !== 'home' ? 0 : props.navbarRef.current?.offsetHeight || 0;
            const offsetTop = targetElement.offsetTop - navbarHeight;
            smoothScrollTo(offsetTop, 800);
        }
    };

    useEffect(() => {
        const locationHash = location.hash.split("#");
        if(location.hash){
            handleScroll(locationHash[1]);
        }
    }, [location]);

    return (
        <div className={styles.container} id='home'>
            <div className={styles.section}>
                <div className={styles.landing_page}>
                    <div className={styles.title}>
                        <div className={styles.title_blur}>
                            <span>Jorge</span>
                            <span>Jorge</span>
                        </div>
                        <div className={styles.title_blur}>
                            <span>Vieira</span>
                            <span>Vieira</span>
                        </div>
                    </div>
                    <div className={styles.info}>
                        <Typewriter
                            texts={['.Porto_Portugal', '.Open_Worldwide', '.Junior_Developer']}
                            speed={100}
                            pause={1500}
                        />
                    </div>
                </div>
                <JumpingBar />
            </div>
            <div className={styles.section}>
                <Section title='about' element={<About setHoverElement={props.setHoverElement} />} isPage={false} blurElement={blurElement} setBlurElement={setBlurElement} setHoverElement={props.setHoverElement} />
                <Section title='experience' element={<Experience setHoverElement={props.setHoverElement} />} isPage={false} blurElement={blurElement} setBlurElement={setBlurElement} setHoverElement={props.setHoverElement} />
                <Section title='projects' element={<Projects setHoverElement={props.setHoverElement} />} isPage={false} blurElement={blurElement} setBlurElement={setBlurElement} setHoverElement={props.setHoverElement} />
                <Section title='contact' element={<Contact setHoverElement={props.setHoverElement} />} isPage={false} blurElement={blurElement} setBlurElement={setBlurElement} setHoverElement={props.setHoverElement} />
            </div>
        </div>
    )
}

export default Home
